import React from 'react';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateBrand } from '../../enums/BrandEnums';

const ModalForUpdateBrand = ({
  brand,
  updateBrand,
  handleClose,
  show,
  brandReducer,
}) => {
  const { error } = brandReducer;

  const fields = [
    {
      name: 'brandName',
      label: ModalForAddOrUpdateBrand.brandNamePlaceholder,
      type: 'text',
    },
  ];

  const initialValues = {
   brandName: brand.brandName ,
  };

  const handleSubmit = (formData) => {
    const updatedBrand = {
      id: brand.id,
     ...formData,
    };
    updateBrand(updatedBrand);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateBrand.titleForUpdateBrand}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.update}
    />
  );
};

export default ModalForUpdateBrand;
